import React from "react";

import Slider from "react-slick";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const reviews = [
    {
      name: "Pawan Gupta",
      position: "Vice President - IT at DHL Express Australia",
      src: "images/testimonial/pawan.jpeg",
      desc: `Ifran is a very fast learner and has a great attitude. 
            He was able to complete his responsibilities without much supervision. 
            He is a great team player and always willing to take responsibilities/initiatives.`,
      rating: 5,
    },
    {
      name: "Pradnya Gaurav",
      position: "Python Developer - DHL Express.",
      src: "images/testimonial/default-user-icon-4.jpg",
      desc: `I had the pleasure to work with Ifran while I was associated with DHL Express Australia. 
              He is very talented and passionate team player with excellent communication and presentation skills. 
              Even being new to web technologies, he picked up Python and Django very quickly.
              He is a fun loving and inspiring person who can perform as an individual contributor and team player as well.
              He learns quickly and I would have no hesitation in working with Ifran again in the future.`,
      rating: 5,
    },
    {
      name: "Edo Kurniawan",
      position: "Senior Manager IT Program Delivery - DHL Express.",
      src: "images/testimonial/edo.jpg",
      desc: `Ifran is a fast learner and diligent person. When joining our team, he learn quickly from his peers + by himself.
              He is a responsible person for any work on hand. He responses quickly and professionally to any ticket. He also have a positive attitude. 
              He is a valuable team member.`,
      rating: 5,
    },
    {
      name: "Vidath Jay",
      position: "ICT Business Analyst - Vinod Patel Company Limited.",
      src: "images/testimonial/vidath.jpg",
      desc: `During the one year period that I worked together with Ifran, he showed an amazing motivation to improve his knowledge while sharing it with the peers. 
							He started to work on the new technologies very frequently which was quite new for everyone, but in a very short period he was able become an expert.
							I think this shows that one of his strengths is a steep learning curve, as well as being a real open-minded and warm personality. 
							Because of this, in my opinion he can be very useful in any new project.`,
      rating: 5,
    },
    {
      name: "Ulrich Hogan",
      position: "GM - Mana Island Resort & Spa.",
      src: "images/testimonial/ulrich.jpg",
      desc: `Ifran has always shown a very positive attitude and excellent performance within our operations in the 
						  capacity of an IT Systems Administrator in our Resort, where he was second in charge of the entire IT 
							department and telecommunications infrastructure.`,
      rating: 5,
    },
    {
      name: "Shiraiz Ahmed",
      position: "ICT Manager - Mana Island Resort & Spa",
      src: "images/testimonial/shear.jpg",
      desc: `He is ambitious and relish a challenge, particularly where technical
							problems require a determined, creative approach.
							He encountered a frustrating series of Technical difficulties which
							he resolved eventually, giving him a great deal of exposure and
							satisfaction in the process.`,
      rating: 5,
    },
    {
      name: "Hirofumi Sasaki",
      position: "Chef - Mana Island Resort & Spa",
      src: "images/testimonial/sasaki.jpg",
      desc: `I worked with Ifran for a few months and find him to be pleasant
              in nature and very hard working. His completes his duties very diligently.
              He was very punctual, precise and always did his in systematic and complete
              manner. His skills with regards to technology especially with computer was
              was excellent and his particular skill of was to be relied on and counted upon`,
      rating: 5,
    },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,           // transition speed (ms)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,       // enable automatic sliding
    autoplaySpeed: 4000,  // time between slides (ms)
    pauseOnHover: true,   // pause autoplay on hover
    pauseOnFocus: true,   // pause autoplay on focus
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Testimonial
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Amazing People I Worked With
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    " rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      className="img-fluid rounded-circle border d-inline-block w-auto"
                      src={value.src}
                      alt=""
                    />
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    “{value.desc}”
                  </p>
                  <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                      <i className="fas fa-star text-warning" key={i} />
                    ))}
                  </span>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
